import { useFreeBuyBonusStore } from '@stores/freeBuyBonusStore'
import { useConfigurationStore } from '@stores'
import React, { useEffect } from 'react'
import { useTranslation } from '@amusnet/translations/react'
import { useFormatMoney } from '@hooks'

const InPlayNotification: React.FC = () => {
    const currency = useConfigurationStore((state) => state.currency)
    const { t } = useTranslation()
    const formatMoney = useFormatMoney()

    const hasActivatedBonus = useFreeBuyBonusStore((state) => state.hasActivatedBonus)
    const setHasActivatedBonus = useFreeBuyBonusStore((state) => state.setHasActivatedBonus)
    const bonuses = useFreeBuyBonusStore((state) => state.bonuses)
    const activeBonus = useFreeBuyBonusStore((state) => state.activeBonus)
    const isThereClaimingError = useFreeBuyBonusStore((state) => state.isThereClaimingError)

    // eslint-disable-next-line no-undef
    let timer: NodeJS.Timeout

    useEffect(() => {
        if (hasActivatedBonus) {
            timer = setTimeout(() => {
                setHasActivatedBonus(false)
            }, 3000)
        }

        return () => clearTimeout(timer)
    }, [hasActivatedBonus])

    if (!hasActivatedBonus || isThereClaimingError) {
        return
    }

    const activeBonusIndex = Math.max(0, activeBonus ? bonuses.findIndex((b) => b.id === activeBonus.id) : 0)
    const bonusName =
        bonuses[activeBonusIndex].typeConfiguration?.freeBuyBonusConfiguration?.label ?? t('gameui.buyBonus')
    const freeBonusNameString = t('gameui.bonusSystem.freeBonusName', { bonusName })
    const baseBet = formatMoney(+bonuses[activeBonusIndex].betValue)

    return (
        <div
            className="fixed top-0 left-1/2 -translate-x-1/2 w-[800px] h-[140px] bg-[#1E2024] text-white flex items-center justify-center z-[9999] mt-[5px] rounded-2xl"
            style={{
                background:
                    'linear-gradient(#1E2024, #1E2024) padding-box, linear-gradient(180deg, #F9C246 0%, #F9E746 47.92%, #F9C246 100%) border-box',
                border: '3px solid transparent',
                borderRadius: '16px',
            }}
        >
            <div className="text-center">
                <span className="text-[30px]">{t('gameui.bonusSystem.youArePlaying')}</span>
                <span className="font-bold text-[30px] mx-3">{`${freeBonusNameString} x ${baseBet}`}</span>
                <span className="text-[30px]">{currency}</span>
            </div>
        </div>
    )
}

export default InPlayNotification
